import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'

export const searchGames = createApiThunk<GameSearchRound[], GameSearchPayload>({
  action: 'games/search',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_GAMES,
  getParams: (payload) => payload,
})
